/**
 * 菜单相关的api
 * @author HYL
 */
import * as API from './'

export default {

  menus: params=>{
    return API.GET('/api/menu/list',params);
  },
  update: params=>{
    return API.POST('/api/menu/update',params);
  },
  menuIdsByRoleId: params=>{
    return API.GET('/api/menu/roleId',params);
  },
  add: params=>{
    return API.POST('/api/menu/add',params);
  },
  remove: params=>{
    return API.postJsonRequest('/api/menu/delete/',params);
  }
}



// WEBPACK FOOTER //
// ./src/api/api_menu.js